import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ palette }) => ({
  modal: {
    // The library wraps its own CSS in `&&`, which doubles the generated
    // class specificity. Plain descendant selectors lose that fight, so
    // `!important` is required to reliably hide the close button and
    // center the title.
    '& .ReferaModal__title': {
      justifyContent: 'center !important',
    },
    '& .ReferaModal__title button': {
      display: 'none !important',
    },
    '& .ReferaModal__title h4': {
      margin: '0 !important',
    },
  },
  modalButtons: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    width: '100%',
  },
  modalButton: {
    minWidth: 120,
  },
  cancelButton: {
    '&:hover': {
      backgroundColor: `${palette.error.main} !important`,
      borderColor: `${palette.error.main} !important`,
      color: '#FFFFFF !important',
    },
  },
  modalContent: {
    // Matches the width the modal previously had when it rendered the
    // installment `Select`, whose `minWidth: 320` drove the modal's size.
    width: '100%',
    minWidth: 320,
    minHeight: '80px',
    gap: '12px',
    textAlign: 'center',
  },
  successIcon: {
    fontSize: 40,
    color: palette.green.main,
  },
}))
